import React from 'react';
import Hero from './Hero';
import MirrorOfTruth from './MirrorOfTruth';
import Evolution from './Evolution';
import SocialProof from './SocialProof';
import Gateway from './Gateway';

const BusinessCode = () => (
  <main className="bg-dark min-h-screen">
    <h1 className="sr-only">
      Female Business Coaching, Soul Business aufbauen & Feminine Leadership
    </h1>
    <Hero />
    <MirrorOfTruth />
    <Evolution />
    <SocialProof />
    <Gateway />
  </main>
);

export default BusinessCode;